module.exports = __webpack_public_path__ + "static/media/grs.77ffe8df.png";